import React, { useState, useEffect } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2'
import { FaTimesCircle } from 'react-icons/fa'
import { useStateContext } from '../../../state/context';
import { useSelector } from 'react-redux';
import { Chart as ChartJs, Title, Tooltip, LineElement, Legend, CategoryScale, LinearScale, PointElement } from 'chart.js'
ChartJs.register(
    Title, Tooltip, LineElement, Legend,
    CategoryScale, LinearScale, PointElement
)

const PatientBloodPressureChartModal = () => {
    const { modals, setModals } = useStateContext()
    const { all_patient_performanceData } = useSelector((state) => state.nurse)
    const blood_pressure_sys_data = []
    const blood_pressure_dia_data = []
    const date_data = []
    const getSystolicData = () => {
        all_patient_performanceData?.map((item, index) => {
            let systolic = parseInt(item.blood_pressure_sys)
            blood_pressure_sys_data.push(systolic)
        })
    }
    const getDiastolicData = () => {
        all_patient_performanceData?.map((item, index) => {
            let diastolic = parseInt(item.blood_pressure_dia)
            blood_pressure_dia_data.push(diastolic)
        })
    }
    const getDateData = () => {
        all_patient_performanceData?.map((item, index) => {
            let date = item.date
            date_data.push(date)
        })
    }

    const [data, setData] = useState({
        labels: date_data,
        datasets: [
            {
                label: "Systolic Chart (mmHg)",
                data: blood_pressure_sys_data,
                backgrounColor: "yellow",
                borderColor: "orange",
                tension: 0.4,
                fill: true,

            },
            {
                label: "Diastolic Chart (mmHg)",
                data: blood_pressure_dia_data,
                backgrounColor: "yellow",
                borderColor: "blue",
                tension: 0.4,
                fill: true,

            },
        ]
    })

    useEffect(() => {

        getSystolicData()
        getDiastolicData()
        getDateData()
    }, [])

    return (
        <>
            <div className='absolute grid h-screen w-full z-20 bg-[#11111180] place-items-center'>
                <div className='bg-white rounded px-[30px] py-[20px] h-[500px] w-[800px]'>
                    <div className='flex justify-end'>
                        <p></p>
                        <FaTimesCircle
                            className='text-dark-yellow cursor-pointer'
                            onClick={() => (
                                setModals({
                                    ...modals,
                                    showBloodPressureChartModal:
                                        !modals.showBloodPressureChartModal,
                                })
                            )

                            }
                            size={20}
                        />
                    </div>

                    <div className='flex flex-col space-y-5 justify-end'>

                        <div className='flex justify-between items-center'>

                            <Line data={data}>PatientTemperatureChartModal</Line>

                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

export default PatientBloodPressureChartModal